import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid2 as Grid} from 'views/components';
import {CompactCardTableExtended} from 'views/module';

import Card from './Card';

const List = (props) => {
  const {data, isLoading, loadMore, hasMore, highlightedCaregiverId, cardsPerRow} = props;

  return (
    <Grid container>
      <CompactCardTableExtended
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadMore}
        hasMore={hasMore}
        highlightedId={highlightedCaregiverId}
        getItemId={(item) => item.caregiverRn}
        cardsPerRow={cardsPerRow}
      />
    </Grid>
  );
};
List.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  visibleCaregiverIds: PropTypes.array,
  highlightedCaregiverId: PropTypes.string,
  cardsPerRow: PropTypes.number,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
